module.exports = __webpack_public_path__ + "static/media/Clap808.848dbc3f.wav";